import apiClient from '@/lib/api/client'
import type { Profile } from '@/types/auth'

export type AuthSessionUser = Pick<
  Profile,
  'id' | 'name' | 'email' | 'role' | 'is_active' | 'person_id' | 'craftsman_id' | 'created_at' | 'updated_at'
>

export type LoginRequest = {
  email: string
  password: string
}

export const authApi = {
  async login(payload: LoginRequest): Promise<AuthSessionUser> {
    const response = await apiClient.post<AuthSessionUser>('auth/login', payload)
    return response.data
  },

  async logout(): Promise<{ logged_out: boolean }> {
    const response = await apiClient.post<{ logged_out: boolean }>('auth/logout')
    return response.data
  },

  /**
   * 現在のセッションを解決する。
   *
   * @param options.signal 呼び出し側から中断するための signal。再試行時に旧リクエストを止める
   * @param options.requestId Cloud Run 側のログと突き合わせるための ID。省略時は client が採番する
   */
  async getSession(options?: {
    signal?: AbortSignal
    requestId?: string
  }): Promise<AuthSessionUser> {
    const response = await apiClient.get<AuthSessionUser>('auth/session', {
      signal: options?.signal,
      headers: options?.requestId ? { 'X-Request-ID': options.requestId } : undefined,
    })
    return response.data
  },
}
